import { Box } from '@chakra-ui/react';
import rightArrow from '@public/assets/icons/control/right-arrow.svg';
import Image from 'next/image';

const RightArrow = ({ onClick, ...rest }: { onClick?: () => void } & Record<string, any>) => (
  <Box
    onClick={onClick ?? null}
    cursor="pointer"
    _hover={{ opacity: 0.5 }}
    transition="opacity ease 200ms"
    w={['26px', '26px', '35px', '35px']}
    minW={['26px', '26px', '35px', '35px']}
    {...rest}
  >
    <Image src={rightArrow} alt="Right Arrow" width={35} height={35} />
  </Box>
);

export default RightArrow;
